import { API } from "aws-amplify";

export function analyze(engine, values) {
  return API.post(`${engine}-engine`, "", { body: values });
}
